export type GreipToolApiEnvelope = {
  success?: boolean;
  status?: string;
  data?: Record<string, unknown>;
  execution_ms?: number;
};

export function getToolResultData(
  payload: unknown,
): Record<string, unknown> | null {
  const response = payload as GreipToolApiEnvelope;
  if (response?.success === true && response.data) {
    return response.data;
  }
  if (response?.status === "success" && response.data) {
    return response.data;
  }
  return null;
}

export function hasToolResultPayload(payload: unknown): boolean {
  return getToolResultData(payload) !== null;
}
